export const enum rule {
  min1symbol,
  max16symbols,
  max32symbols,
  max20symbols,
  max64symbols,
  max128symbols,
  max254symbols,
  max320symbols,
  rule2,
  rule3,
  rule4,
  rule5,
  rule6,
  '2LETTERS',
  '1LETTER',
  '5numbers',
  rule9,
  rule10,
  rule11,
  rule12,
  rule13,
  rule14,
  rule15,
  rule16,
  rule17,
  rule18,
  letters,
  email,
  'letters&numbers',
  'letters&numbers&symbols&space',
  'letters&numbers&underscore',
  latinLettersAndNumbersCaps,
  lettersNumbersSpaces,
  lettersNumbersSpacesUnderscore,
  cityName,
  reportName,
  personName,
}

const regexp = {
  [rule.rule2]: /^[\w_ ]+$/,
  [rule.rule3]: /^[\w_-]+$/,
  [rule.rule4]: /^[\w_ -]+$/,
  [rule.rule5]: /^[A-Za-z0-9',. -]+$/,
  [rule.rule6]: /^[\w_ -|]+$/,
  [rule['2LETTERS']]: /^[A-Z]{2}$/,
  [rule['1LETTER']]: /^[A-Z]$/,
  [rule['5numbers']]: /^\d{5}$/,
  [rule.rule9]: /^\d+([.]\d{0,4})?$/,
  [rule.rule10]: /^\d{0,2}([.]\d{0,2})?$|^100$/,
  [rule.rule11]: /^\d+([.]\d{0,4})?$|^NaN$/,
  [rule.rule12]: /[^ -~]+/,
  [rule.rule13]: /^([\w\-_ ]+;){0,31}[\w\-_ ]+$/,
  [rule.rule14]: /^[a-zA-Z0-9-]+$/,
  [rule.rule15]: /^[a-zA-Z0-9 .,()#\-&:]+$/,
  [rule.rule16]: /^((?![<>;=+?])[ -~']|)+$/,
  [rule.rule17]: /^(?!.*[\x00-\x1F\x7F])[a-zA-Z _\-&]+$/,
  [rule.rule18]: /^(?!.*[\x00-\x1F\x7F])[a-zA-Z0-9 \-&]+$/,
  [rule.letters]: /^[A-Za-z]+$/,
  [rule.email]: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  [rule['letters&numbers']]: /^[A-Za-z\d]+$/,
  [rule['letters&numbers&symbols&space']]: /^((?![<>;=+?])[ -~№±§ʼ₴'])+$/,
  [rule['letters&numbers&underscore']]: /^[A-Za-z0-9_]+$/,
  [rule['latinLettersAndNumbersCaps']]: /^[A-Z0-9]+$/,
  [rule.lettersNumbersSpaces]: /^[A-Za-z\d ]+$/,
  [rule.lettersNumbersSpacesUnderscore]: /^[A-Za-z\d _]+$/,
  [rule.cityName]: /^[A-Za-z0-9'. -]+$/,
  [rule.reportName]: /^(?!.*[\x00-\x1F\x7F])[a-zA-Z0-9 _-]+$/,
  [rule.personName]: /^[A-Za-z-]+$/,
}

const message = {
  [rule.min1symbol]: 'Minimum length of field is 1 character',
  [rule.max16symbols]: 'Maximum length of field is 16 characters',
  [rule.max32symbols]: 'Maximum length of field is 32 characters',
  [rule.max20symbols]: 'Maximum length of field is 20 characters',
  [rule.max64symbols]: 'Maximum length of field is 64 characters',
  [rule.max128symbols]: 'Maximum length of field is 128 characters',
  [rule.max254symbols]: 'Maximum length of field is 254 characters',
  [rule.max320symbols]: 'Maximum length of field is 320 characters',
  [rule.rule2]: 'Only Latin letters, numbers or underscore are allowed',
  [rule.rule3]: 'Only Latin letters, numbers, underscore or minus are allowed',
  [rule.rule4]: 'Only Latin letters, numbers, underscore, minus or space are allowed',
  [rule.rule5]: 'Only Latin letters, numbers, apostrophe, comma, dots, minus or space are allowed',
  [rule.rule6]: 'Only Latin letters, numbers, minus, space or | are allowed',
  [rule['2LETTERS']]: '2 Latin letters in upper case',
  [rule['1LETTER']]: 'Only one Latin letter in upper case',
  [rule['5numbers']]: 'Can contain 5 digits',
  [rule.rule9]: 'Only number with no more 4 decimal separated by dot',
  [rule.rule10]: 'Can contain percentage value <= 100 with no more 2 decimal separated by dot',
  [rule.rule11]: 'Only number with no more 4 decimal separated by dot or NaN',
  [rule.rule12]: 'Only ASCII characters are allowed',
  [rule.rule13]: 'Only unique 1-32 items (Latin letters, numbers, _, - or space) separated by semicolon are allowed',
  [rule.rule14]: 'Only Latin letters, numbers, and dash are allowed',
  [rule.rule15]: 'Only Latin letters, numbers, spaces, and these characters are allowed: , . ( ) # - & :',
  [rule.rule16]: 'Only ASCII characters are allowed (excluding <, >, ;, =, +, ?).',
  [rule.rule17]: 'Only Latin letters, spaces, and these characters are allowed: _ - &',
  [rule.rule18]: 'Only Latin letters, numbers, spaces, and these characters are allowed: - &',
  [rule.letters]: 'Only Latin letters are allowed',
  [rule.email]: "Email isn't valid",
  [rule['letters&numbers']]: 'Only Latin letters and numbers are allowed',
  [rule['letters&numbers&symbols&space']]: 'Only Latin letters, numbers and symbols are allowed',
  [rule['letters&numbers&underscore']]: 'Only Latin letters, numbers and underscore are allowed',
  [rule['latinLettersAndNumbersCaps']]: 'Only uppercase Latin letters and numbers are allowed',
  [rule['lettersNumbersSpaces']]: 'Only Latin letters, numbers, and spaces are allowed',
  [rule.lettersNumbersSpacesUnderscore]: 'Only Latin letters, numbers, spaces, and underscore are allowed',
  [rule.cityName]: 'Only Latin letters, numbers, apostrophe, dots, minus or space are allowed',
  [rule.reportName]: 'Only Latin letters, numbers, spaces, and these characters are allowed: _ -',
  [rule.personName]: 'Only Latin letters and hyphens are allowed',
}

export const validator = (value: string, rules: rule[], validationMessage?: string): string => {
  for (const r of rules) {
    if (r === rule.min1symbol && value.length < 1) {
      return validationMessage ?? message[rule.min1symbol]
    } else if (r === rule.max64symbols && value.length > 64) {
      return message[rule.max64symbols]
    } else if (r === rule.rule2 && !regexp[rule.rule2].test(value)) {
      return message[rule.rule2]
    } else if (r === rule.rule3 && !regexp[rule.rule3].test(value)) {
      return message[rule.rule3]
    } else if (r === rule.rule4 && !regexp[rule.rule4].test(value)) {
      return message[rule.rule4]
    } else if (r === rule.rule5 && !regexp[rule.rule5].test(value)) {
      return message[rule.rule5]
    } else if (r === rule.rule6 && !regexp[rule.rule6].test(value)) {
      return message[rule.rule6]
    } else if (r === rule['2LETTERS'] && !regexp[rule['2LETTERS']].test(value)) {
      return message[rule['2LETTERS']]
    } else if (r === rule['1LETTER'] && !regexp[rule['1LETTER']].test(value)) {
      return message[rule['1LETTER']]
    } else if (r === rule['5numbers'] && !regexp[rule['5numbers']].test(value)) {
      return message[rule['5numbers']]
    } else if (r === rule.rule9 && !regexp[rule.rule9].test(value)) {
      return message[rule.rule9]
    } else if (r === rule.rule10 && !regexp[rule.rule10].test(value)) {
      return message[rule.rule10]
    } else if (r === rule.rule11 && !regexp[rule.rule11].test(value)) {
      return message[rule.rule11]
    } else if (r === rule.rule12 && regexp[rule.rule12].test(value)) {
      return message[rule.rule12]
    } else if (r === rule.rule13) {
      const uniqueValues = Array.from(new Set(value.split(';'))).join(';')
      if (!regexp[rule.rule13].test(value) || uniqueValues !== value) {
        return message[rule.rule13]
      }
    } else if (r === rule.max16symbols && value.length > 16) {
      return message[rule.max16symbols]
    } else if (r === rule.max32symbols && value.length > 32) {
      return message[rule.max32symbols]
    } else if (r === rule.max20symbols && value.length > 20) {
      return message[rule.max20symbols]
    } else if (r === rule.max320symbols && value.length > 320) {
      return message[rule.max320symbols]
    } else if (r === rule.max128symbols && value.length > 128) {
      return message[rule.max128symbols]
    } else if (r === rule.max254symbols && value.length > 254) {
      return message[rule.max254symbols]
    } else if (r === rule.letters && !regexp[rule.letters].test(value)) {
      return message[rule.letters]
    } else if (r === rule.email && !regexp[rule.email].test(value)) {
      return message[rule.email]
    } else if (r === rule['letters&numbers'] && !regexp[rule['letters&numbers']].test(value)) {
      return message[rule['letters&numbers']]
    } else if (r === rule['letters&numbers&symbols&space'] && !regexp[rule['letters&numbers&symbols&space']].test(value)) {
      return message[rule['letters&numbers&symbols&space']]
    } else if (r === rule.rule14 && !regexp[rule.rule14].test(value)) {
      return message[rule.rule14]
    } else if (r === rule.rule15 && !regexp[rule.rule15].test(value)) {
      return message[rule.rule15]
    } else if (r === rule.rule16 && !regexp[rule.rule16].test(value)) {
      return message[rule.rule16]
    } else if (r === rule.rule17 && !regexp[rule.rule17].test(value)) {
      return message[rule.rule17]
    } else if (r === rule.rule18 && !regexp[rule.rule18].test(value)) {
      return message[rule.rule18]
    } else if (r === rule['letters&numbers&underscore'] && !regexp[rule['letters&numbers&underscore']].test(value)) {
      return message[rule['letters&numbers&underscore']]
    } else if (r === rule['latinLettersAndNumbersCaps'] && !regexp[rule['latinLettersAndNumbersCaps']].test(value)) {
      return message[rule['latinLettersAndNumbersCaps']]
    } else if (r === rule['lettersNumbersSpaces'] && !regexp[rule['lettersNumbersSpaces']].test(value)) {
      return message[rule['lettersNumbersSpaces']]
    } else if (r === rule.lettersNumbersSpacesUnderscore && !regexp[rule.lettersNumbersSpacesUnderscore].test(value)) {
      return message[rule.lettersNumbersSpacesUnderscore]
    } else if (r === rule.cityName && !regexp[rule.cityName].test(value)) {
      return message[rule.cityName]
    } else if (r === rule.reportName && !regexp[rule.reportName].test(value)) {
      return message[rule.reportName]
    } else if (r === rule.personName && !regexp[rule.personName].test(value)) {
      return message[rule.personName]
    }
  }
  return ''
}
